import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from 'i18next';
import logOut from '../../Logout/actions';

class AutoLogout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      timerid: -1,
    };
    this.getSessionTimeout = this.getSessionTimeout.bind(this);
  }

  componentDidMount() {
    this.setState({ timerid: this.getSessionTimeout() });
  }

  componentWillUnmount() {
    clearTimeout(this.state.timerid);
  }

  getSessionTimeout() {
    if (!this.props.isAuthenticated) {
      return undefined;
    }

    const locationURL = typeof window !== 'undefined' ? window.location.pathname !== '/' : false;

    if (locationURL) {
      const sessionTimeOut = `${t('Timeout')}`;
      const timerid = setTimeout(() => {
        this.logout();
      }, 1000 * 60 * sessionTimeOut);
      return timerid;
    }

    return undefined;
  }

  logout = () => {
    sessionStorage.clear();
    this.props.logOut();
  };

  render() {
    return null;
  }
}

AutoLogout.propTypes = {
  isAuthenticated: PropTypes.bool,
  logOut: PropTypes.func,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.profile.isAuthenticated,
});

const mapDispatchToProps = (dispatch) => ({
  logOut: () => dispatch(logOut({ isSessionTimeout: true })),
});

export default connect(mapStateToProps, mapDispatchToProps)(AutoLogout);
